import React, {useContext} from 'react';
import {getFreshIdToken} from '../../utils/authUtil';

export const DiscoveryExperimentContext = React.createContext(null);

const endpoint = path =>
  `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/ereader/discover/experiment/${path}`;

export const exposeDiscoveryExperiment = async () => {
  const token = await getFreshIdToken();
  const response = await fetch(endpoint('exposure'), {
    method: 'POST',
    headers: {'br-token': token, 'Content-Type': 'application/json'},
    body: JSON.stringify({viewport: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'})
  });
  if (!response.ok) throw new Error('Discovery experiment unavailable');
  return response.json();
};

export const recordDiscoveryExperimentAction = (action, phase) => {
  getFreshIdToken().then(token => fetch(endpoint('action'), {
    method: 'POST',
    headers: {'br-token': token, 'Content-Type': 'application/json'},
    body: JSON.stringify({action, phase}),
    keepalive: true
  })).catch(() => {}); // Measurement cannot interrupt browsing.
};

export const useDiscoveryExperimentTracking = () => {
  const phase = useContext(DiscoveryExperimentContext);
  return action => {if (phase) recordDiscoveryExperimentAction(action, phase);};
};
